<template>
  <div class="home">
                <section>
                    <div class="py-8 px-8">
                    <div class="d-flex flex-wrap align-items-center justify-content-between">
                        <div class="col-12 col-lg-auto mb-3 mb-lg-0">
                            <div class="d-flex align-items-center">
                                <h4 class="mb-0 me-2">{{$t('categories')}}</h4>
                            </div>
                        </div>
                        <div class="col-12 col-lg-auto d-flex align-items-center gap-2">
                            <div class="input-group flex-grow-1" style="border-bottom: 1px solid #ddd;">
                                <input class="form-control border-0 search-input" autocomplete="off" type="text" v-model="search" :placeholder="$t('search')">
                            </div>
                            <button @click="showFilters = !showFilters" class="btn btn-outline-secondary d-md-none">
                                <AppIcon name="bi-funnel" class="bi bi-funnel" />
                            </button>
                        </div>
                    </div>
                    </div>
                </section>
      
            <section class="">
                <div class="px-8">


                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3">
                        <template v-if="helper.checkAccess('create_categories') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('category')}}</span>
                            </button>
                        </template>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" :class="{'d-none d-md-flex': !showFilters}">
                        <div class="col d-none d-md-block"></div>
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker class="w-100" :clearable="true" :editable="false" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        <div class="col-md-2 d-none d-md-block">
                            <template v-if="helper.checkAccess('create_categories') != -1">
                                <button @click="create" class="btn btn-sm btn-success w-100">
                                    <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                    <span>{{$t('category')}}</span>
                                </button>
                            </template>
                        </div>
                    </div>
                    
                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCategories)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('image')}}</th>
                                    <sortable-table-header field="name" label="name" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCategories)" />
                                    <sortable-table-header field="created_at" label="created_at" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getCategories)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="category in categories" :key="category.id" :class="{'table-active': category.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="category.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td class="py-5 px-6"><router-link  :to="`/categories/${category.id}`"><b>{{category.reference }}</b></router-link></td>
                                <td class="py-5 px-6"><img v-if="category.image" :src="category.image" alt="Category Image" style="max-height: 50px;"></td>
                                <td class="py-5 px-6">{{category.name}}</td>
                                <td class="py-5 px-6">{{formatDate(category.created_at)}}</td>
                                <td class="py-5 px-6">
                                    <router-link :to="`/categories/${category.id}`" style="padding: 5px;margin: 0 2px 0 0;font-size: 12px !important;" class="btn btn-outline-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('details')}}
                                    </router-link>
                                    <button v-if="helper.checkAccess('edit_categories') != -1" @click="editRow(category)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button v-if="helper.checkAccess('delete_categories') != -1" @click="deleteRow(category)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                </td>
                            </tr>

                            </tbody>
                        </table>

                        <div v-if="loading === false && count > categories.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getCategories" />
                        </div>

                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !categories.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-folder" class="bi bi-folder text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_categories_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_categories') }}</p>
                        <template v-if="helper.checkAccess('create_categories') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_category') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !categories.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_category_found')}}.</div>

                </div>
                
                </div>
            </section>

        <!-- Bulk Action Bar -->
        <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
            <div class="d-flex align-items-center">
                <span class="fw-bold me-2">{{ selectedCount }}</span>
                <span class="text-muted">{{$t('selected')}}</span>
            </div>
            <div class="d-flex gap-2">
                <button v-if="helper.checkAccess('delete_categories') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                    <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                </button>
            </div>
        </div>

        <!-- create Modal -->
        <div class="modal fade" id="create-modal" tabindex="-1" aria-labelledby="create-modal" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{$t('create_category')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
            </div>
            <div class="modal-body" style="text-align:left">

                <div class="mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                    <input v-model="category.name" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Category x">
                </div>

                <div class="col-sm-4">
                    <label class="form-label">{{$t('image')}}</label>
                    <div class="image-preview me-3 mr-2">
                        <div 
                          class="drop-zone" 
                          @dragover.prevent
                          @drop.prevent="handleFileDrop"
                          @click="$refs.fileInput.click()"
                          :class="{'has-image': category.image }"
                        >
                          <img v-if="category.image" :src="category.image" class="preview-image" />
                          <div v-else class="drop-zone-content">
                            <AppIcon name="bi-cloud-upload" class="bi bi-cloud-upload" style="font-size: 24px;" />
                            <p class="mt-2 mb-0">{{$t('drag_drop_or_click')}}</p>
                            <small class="text-muted">{{$t('max_size_5mb')}}</small>
                            <!-- <span v-if="business && business.status !== 'active'" class="badge bg-secondary ms-2">{{$t('pro')}}</span> -->
                          </div>
                        </div>
                        <input 
                          type="file" 
                          ref="fileInput" 
                          @change="handleFileUpload" 
                          accept="image/*" 
                          class="d-none"
                        >
                    </div>
                </div>


            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button type="button" class="btn btn-success" :disabled="loading || category.name.length < 2" @click="save"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('create')}}</button>
            </div>
            </div>
        </div>
        </div>
        <!-- create modal -->


        <!-- Edit Modal -->
        <div class="modal fade" id="edit-modal" tabindex="-1" aria-labelledby="edit-modal" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">{{$t('edit_category')}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
            </div>
             <div class="modal-body" style="text-align:left">

                <div class="mb-3">
                    <label for="exampleFormControlInput1" class="form-label">{{$t('name')}}</label>
                    <input v-model="category.name" type="string" class="form-control" id="exampleFormControlInput1" placeholder="Category x">
                </div>
                <div class="col-sm-4">
                    <label class="form-label">{{$t('image')}}</label>
                    <div class="image-preview me-3 mr-2">
                        <div 
                          class="drop-zone" 
                          @dragover.prevent
                          @drop.prevent="handleFileDrop"
                          @click="$refs.fileInput.click()"
                          :class="{'has-image': category.image }"
                        >
                          <img v-if="category.image" :src="category.image" class="preview-image" />
                          <div v-else class="drop-zone-content">
                            <AppIcon name="bi-cloud-upload" class="bi bi-cloud-upload" style="font-size: 24px;" />
                            <p class="mt-2 mb-0">{{$t('drag_drop_or_click')}}</p>
                            <small class="text-muted">{{$t('max_size_5mb')}}</small>
                            <!-- <span v-if="business && business.status !== 'active'" class="badge bg-secondary ms-2">{{$t('pro')}}</span> -->
                          </div>
                        </div>
                        <input 
                          type="file" 
                          ref="fileInput" 
                          @change="handleFileUpload" 
                          accept="image/*" 
                          class="d-none"
                        >
                    </div>
                </div>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                <button type="button" class="btn btn-success" :disabled="loading || (category.name && category.name.length < 2)" @click="update"> <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />{{$t('edit')}}</button>
            </div>
            </div>
        </div>
        </div>
        <!-- Edit modal -->


        <div class="modal fade" id="show-products" tabindex="-1" aria-labelledby="show-products" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$t('products')}}</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
                </div>
                <div v-if="showProductsModalisOpen === true" class="modal-body" style="text-align:left">

                <div class="px-4 pb-4 mb-6 bg-white rounded shadow">
                    
                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">

                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('label')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('updated_at')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('created_at')}}</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="product in category.products" :key="product.id">
                                    <td class="py-5 px-6">{{product.reference}}</td>
                                    <td class="py-5 px-6">{{product.label}}</td>
                                    <td class="py-5 px-6">{{formatDate(product.updated_at)}}</td>
                                    <td class="py-5 px-6">{{formatDate(product.created_at)}}</td>
                                </tr>

                            </tbody>
                        </table>

                    </div>
                    <!-- table -->

                </div>
             
            </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"><AppIcon name="bi-x-lg" class="bi bi-x-lg me-1" />{{$t('close')}}</button>
                </div>
                </div>
            </div>
        </div>

  </div>
</template>

<script>
// @ is an alias to /src
import helper from '../../helper'
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import sortableList from '../../mixins/sortableList'
const maxAllowedSize = 5 * 1024 * 1024; //5MB

export default {
  name: 'Category',
  persistedFilterState: {
    key: 'categories',
    fields: ['search', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components :{
    DatePicker,
  },
  data(){
    return {
        search : '',
        categories : [],
        count : 0,
        page : 1,
        category : {
            id : null,
            name : '',
            products : []
        },
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        showFilters: false,
        createModal : null,
        editModal : null,
        loading : false,
        per_page : 25,
        pagination : [],
        showProductsModalisOpen : false,
        showProductModal : null,
        url : '',
        imageFile : null,
        isSelectedItem: false
    }
  },
  mounted(){
    window.mixpanel.track("category");

    //check permissions
    //check permissions
    if(!helper.checkModuleIsEnabled('categories')) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_categories') == -1) return this.$router.push({path : '/'})
    if(helper.checkAccess('view_categories') == -2) return this.$router.push({path : '/subscribe'})

    // Initialize this_month date range
    this.handleDateRangeChange()
    
    this.getCategories()

    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('create-modal'))
    
    // eslint-disable-next-line no-undef
    this.editModal = new bootstrap.Modal(document.getElementById('edit-modal'))

  },
  methods : {
    create(){
        this.clearForm()
        this.createModal.show()
    },
    editRow(row){
        this.category = row 
        this.editModal.show()
    },
    async save(){
        try{
            this.loading = true
            await helper.customPost(`${process.env.VUE_APP_API}/categories`,this.category,{showToast:true})
            this.loading = false
            this.getCategories()
            this.clearForm()
            this.createModal.hide()
        }catch(error){
            this.loading = false
        }
    },
    async update(){
        try{
            this.loading = true
            await helper.customPatch(`${process.env.VUE_APP_API}/categories/${this.category.id}`,this.category)
            this.loading = false
            this.clearForm()
            this.editModal.hide()
            this.getCategories()
        }catch(error){
            this.loading = false
        }

    },
    async deleteRow(row){
        this.$swal.fire({
        title: this.$t('are_you_sure'),
        text : this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                await helper.customDelete(`${process.env.VUE_APP_API}/categories/${row.id}`)
                this.categories = helper.withoutDeletedRecords(this.categories, row.id)
                this.count = Math.max(0, this.count - 1)
            }
        })
    },
    clearForm(){
        this.category = {
            id : null,
            name : ''
        }
    },
    async getCategories(page){
        try{
            this.loading = true
            this.page = page || 1
            const params = new URLSearchParams({ page: this.page, per_page: this.per_page })
            this.appendSortParams(params)
            if (this.start) {
                params.append('start', this.start)
                params.append('end', this.end)
            }
            
            this.categories = []

            if(this.search != ""){
                params.append('keyword', this.search)
            }
            const url = `${process.env.VUE_APP_API}/categories?${params.toString()}`
            
            const response = await helper.customGet(url)
            this.loading = false
            this.categories = response.data.data
            
            for(let i = 0 ; i < this.categories.length ; i++){
                this.$set(this.categories[i], 'selected', false)
            }

            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
        }catch(error){
            this.loading = false
        }

    },
    generatePDF() {
        const doc = new jsPDF();

        const data = []
        for(let i = 0 ; i < this.categories.length ; i++){
            const category = this.categories[i]
            
            data.push([
                category.id,
                category.name,
                this.formatDate(category.created_at)
            ])
        }
        doc.text("Categories", 15, 10);
        autoTable(doc,
        {
            head: [["Id", "Nom", "Créé à"]],
            body: data
        })
        doc.save('categories.pdf')
    },
    generateCsv(){
        const data = []
        for(let i = 0 ; i < this.categories.length; i++){
            const category = this.categories[i]
            data.push({
                "Id" : category.id,
                "Nom" : category.name,
                "Crée à" : this.formatDate(category.created_at)
            })
        }
        return data
    },
    showProducts(category){
        this.category = category
        this.showProductsModalisOpen = true;
        this.showProductModal.show()
    },
    formatDate(date) { return helper.formatDate(date) },
    async handleFileUpload(event) {
        this.imageFile = null
        this.category.image = null
      const file = event.target.files[0];
      if (!file) return;

      // Create preview
      this.imageFile = file;
    if(file.size > maxAllowedSize) return alert('File Too large please upload file less than 5mb')
      this.category.image = URL.createObjectURL(file);
      await this.uploadImage()
      this.event = null
    },
    async uploadImage() {
      if (!this.imageFile) return null;

      const url = await this.onUpload(this.imageFile);
        this.category.image = url
    },
    async onUpload(file){
        if(file.size > maxAllowedSize) return alert('File Too large please upload file less than 5mb')
        this.loading = false
        // if(this.business && this.business.status != 'active') return;
        return helper.customUploadFile(file,`businesses/${this.business.id}/attachments/${helper.generateRandString(20)}`,{products: true})
    },
    handleFileDrop(event) {
    //   if (this.business && this.business.status !== 'active') return;
      const file = event.dataTransfer.files[0];
      if (!file) return;
      this.handleFileUpload({ target: { files: [file] } });
    },
    // Handle date range selection
    handleDateRangeChange() {
      if (this.dateRangeOption === '') {
        this.range = []
        this.start = null
        this.end = null
        this.getCategories()
      } else if (this.dateRangeOption === 'today') {
        const start = new Date()
        const end = new Date()
        this.range = [start, end]
      } else if (this.dateRangeOption === 'yesterday') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'last_week') {
        const start = new Date()
        const end = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 14)
        end.setTime(end.getTime() - 3600 * 1000 * 24 * 7)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'this_month') {
        const start = new Date()
        const end = new Date()
        start.setDate(1)
        this.range = [start, end]
      } else if (this.dateRangeOption === 'custom') {
        this.range = []
      }
    },
    changeSelectedItem(){
        this.isSelectedItem = this.categories.find(category => category.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.categories.forEach(c => c.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.categories.filter(c => c.selected).map(c => c.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/categories/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.categories = helper.withoutDeletedRecords(this.categories, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('categories_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    }
  },
  watch : {
    async search(){
        if(this.search.length > 2){
            try{
                this.loading = true
                const response = await helper.customGet(`${process.env.VUE_APP_API}/categories?keyword=${this.search}`)
                this.categories = response.data.data
                this.count = response.data.count
                this.loading = false
            }catch(error){
                this.loading = false
            }
        }
        if(this.search == '') return this.getCategories()
    },
    range(){
        

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getCategories()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getCategories()
        }else{
            this.categories = []
        }
    },
    per_page(){
        this.getCategories(this.page)
    }
  },
  computed : {
    isFiltered() {
      return (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.search && this.search.length > 0) ||
             (this.range && this.range.length > 0);
    },
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS },
    helper(){ return helper },
    areAllSelected() {
      return this.categories.length > 0 && this.categories.every(c => c.selected);
    },
    selectedCount() {
      return this.categories.filter(c => c.selected).length;
    }
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
    .drop-zone {
        border: 2px dashed #ccc;
        border-radius: 8px;
        padding: 20px;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;
        background: #f8f9fa;
        min-height: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .drop-zone:hover:not(.disabled) {
        border-color: #534dff;
        background: #f0f0ff;
    }
    .drop-zone.disabled {
        cursor: not-allowed;
        opacity: 0.7;
    }
    .drop-zone.has-image {
        padding: 0;
        border: none;
    }
    .preview-image {
        width: 100%;
        height: 150px;
        object-fit: cover;
        border-radius: 8px;
    }
    .drop-zone-content {
        color: #666;
    }
    .drop-zone-content i {
        color: #534dff;
    }
</style>
